import SlideOutButton from "../common/SlideOutButton";
import useDevUnlockStagedPurchaseOrder from "./useDevUnlockStagedPurchaseOrder";

interface UnlockStagedPurchaseOrderButtonProps {
  stagedPurchaseOrderId: string;
}

const UnlockStagedPurchaseOrderButton = ({ stagedPurchaseOrderId }: UnlockStagedPurchaseOrderButtonProps) => {
  const unlockRequest = useDevUnlockStagedPurchaseOrder(stagedPurchaseOrderId);

  return <SlideOutButton text="Unlock Staged Purchase Order" onClick={() => unlockRequest.request()} />;
}

export default UnlockStagedPurchaseOrderButton;
